import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';

import i18n from 'i18n-js';
import { navigateTo, isPhone } from '@helpers';
import TablerWrapper from '@components/auntification/tablerWrapper';
import { AUTH_LOGO_MARGIN_TOP_WELCOME, AUTH_OFFSET_WELCOME } from '@components/auntification/tablerWrapper/constants';
import Logo from '@components/logo/index';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import useStatusBar from '@components/common/useStatusBar';

const Welcome = ({ route, C }) => {
  const email = (route.params && route.params.email) || 'Error, try again';
  const registered = (route.params && route.params.registered) || false;
  const toManualLogin = () => {
    navigateTo('Login', { email });
  };
  useStatusBar({ C });

  return (
    <TablerWrapper offset={AUTH_OFFSET_WELCOME}>
      <Logo
        title={i18n.t('Welcome to Smart Factory!')}
        withText={false}
        marginTop={AUTH_LOGO_MARGIN_TOP_WELCOME}
        fontSize={22}
        lineHeight={33}
      />
      <View style={styles.clickOnLinkBox}>
        <Text style={[styles.clickOnLink, { color: C('Label / Light / Primary') }, font.Body]}>
          {i18n.t('Click on the confirmation link sent by email to')}
        </Text>
      </View>
      <Text style={[styles.email, { color: C('Label / Light / Primary') }, font.Body]}>{email}</Text>
      <TouchableOpacity style={styles.loginQRBox} onPress={toManualLogin}>
        {registered ? (
          <Text style={[styles.loginQRText, { color: C('Label / Light / Secondary') }, font['Button 2']]}>{i18n.t('Log In manually instead')}</Text>
        ) : (
          <Text />
        )}
      </TouchableOpacity>
    </TablerWrapper>
  );
};

export default ColorWrapper(Welcome);

const styles = StyleSheet.create({
  clickOnLinkBox: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: !isPhone ? 27 : 32,
    marginTop: !isPhone ? 13 : 16,
  },
  clickOnLink: {
    fontWeight: 'normal',
    fontSize: 17,
    textAlign: 'center',
    lineHeight: 20,
    letterSpacing: 0.02,
    maxWidth: 280,
  },
  email: {
    fontWeight: 'normal',
    fontSize: 17,
    textAlign: 'center',
    letterSpacing: 0.02,
  },
  loginQRBox: {
    marginTop: 72,
  },
  loginQRText: {
    fontWeight: '500',
    fontSize: 13,
    textAlign: 'center',
    letterSpacing: 0.01,
    color: '#6C6C6C', // ColorPoint
  },
});
